export default __webpack_public_path__ + "static/media/Chartgraph.72d88781.png";